module.exports = __webpack_public_path__ + "static/media/border-style-alt.4d6d0b91.svg";